import {ChangeDetectorRef, Component, OnInit, Output} from '@angular/core';
import {AbstractVisbosControl} from '../../../core/visbos-core/ui/forms/abstract-visbos-control';
import {FormBuilder, FormControl} from '@angular/forms';
import {BehaviorSubject, Observable} from 'rxjs';
import {SessionActions} from '../../../shared/actions';
import {AccountingUnitService} from '../../services/accounting-unit.service';
import {map} from 'rxjs/operators';
import {Account} from '../../../shared/view-model/crm/account.type';

@Component({
  selector: 'vb-account-selection',
  templateUrl: './account-selection.component.html',
  styleUrls: ['./account-selection.component.css']
})
export class AccountSelectionComponent extends AbstractVisbosControl<Account, FormControl> implements OnInit {

  accounts$: Observable<Account[]>;

  @Output()
  itemChanged = new BehaviorSubject<Account>(null);

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions, private accountService: AccountingUnitService) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    this.accounts$ = this.accountService.getAccounts().pipe(
      map(res => res.data.accounts)
    );
  }

  buildControlContent(values?: Account): FormControl {
    return AccountSelectionComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder): FormControl {
    return fb.control(null);
  }

  public setDefaultValues(item?: Account): { [controlKey: string]: any } | any {
    return this.setValue(item, 'cuid', null);
  }

  public onItemChangedEvent(account: Account) {
    this.itemChanged.next(account);
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/components/account-selection/account-selection.component.ts